import { Injectable, inject, signal, WritableSignal } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, map, catchError, of, shareReplay, take } from 'rxjs';
import { env } from '../../../../environments/environment';
import { SelectOption, TipologicaItem, TipologicaResponse } from '../../../shared/models/tipologicaForm';

@Injectable({ providedIn: 'root' })
export class FormOptionsService {
  private http = inject(HttpClient);
  private baseUrl = `${env.api.baseUrlPublic}/tipo`;


  private _yesNo = signal<SelectOption[]>([
    { value: 'si', label: 'Sì' },
    { value: 'no', label: 'No' },
  ]);
  yesNo = this._yesNo.asReadonly();


  private streamCache = new Map<string, Observable<SelectOption<TipologicaItem>[]>>();
  private signalCache = new Map<string, WritableSignal<SelectOption<TipologicaItem>[]>>();


  private getByType(type: string): Observable<TipologicaResponse> {
    const url = `${this.baseUrl}/${type}`;
    return this.http.get<TipologicaResponse>(url);
  }

  /** Mapping della select */
  private getOptions$(type: string): Observable<SelectOption<TipologicaItem>[]> {
    if (!this.streamCache.has(type)) {
      const stream$ = this.getByType(type).pipe(
        map(res => (res.elements ?? []).map(el => ({
          value: el.codice,
          label: el.descrizione,
          raw: el
        })))
      );
      this.streamCache.set(type, stream$);
    }
    return this.streamCache.get(type)!;
  }

  /**
   * Ritorno per una tipologica
   */
  optionsSignal(type: string) {
    if (!this.signalCache.has(type)) {
      const data = signal<SelectOption<TipologicaItem>[]>([]);
      this.signalCache.set(type, data);
      this.getOptions$(type).pipe(take(1)).subscribe(data.set);
    }
    return this.signalCache.get(type)!.asReadonly();
  }


}
